// DS:
// DS1.11
import React from 'react';
import cn from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Dots.scss';
const MINIMUM_PAGES = 2;
const Dots = ({ total, current, className, onClick })=>{
    if (total < MINIMUM_PAGES) {
        return null;
    }
    const pages = Array.from(Array(total), (_, i)=>i);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, pages.map((page)=>/*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            key: `page-${page}`,
            className: cn(s['dot'], page === current && s['current']),
            onClick: onClick && ((e)=>onClick(page, e))
        })));
};
Dots.displayName = 'Dots';
export default Dots;

//# sourceMappingURL=Dots.js.map